import styled from 'styled-components';

export const ContainerHome = styled.div`
    padding: 1vh;
    display: flex;
    flex-direction: column;
`;

export const ContainerProduct = styled.div`
    min-height: 81vh;
`;
